import React, { Component } from 'react';
import { ssSessionUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { Tooltip } from 'antd';

const
{ getDataType } = ssCommonUtils,
{ hasPermission } = ssSessionUtils;

export default class Permission extends Component {
    constructor(props) { super(props); }

    render() {
        const { type, population } = this.props;
        let { children, tooltip } = this.props;
        tooltip = tooltip || false;

        if(children != null) {
            switch(getDataType(children)) {
                case 'Object':
                    return hasPermission(type, population)
                        ? React.cloneElement(children, { style: { display: 'inline-block' }})
                        : null;
                    break;
                case 'Array':
                    let _children = children.map(c => React.cloneElement(c, { style: { display: 'inline-block' }}));
                    switch(children.length) {
                        case 1:
                            return hasPermission(type, population) ? _children[0] : null;

                        case 2:
                            return hasPermission(type, population) ? _children[0] : !tooltip
                                ? _children[1]
                                : React.cloneElement(_children[1], { children: (
                                    <Tooltip title='Permission required.'>
                                        {React.cloneElement(_children[1].props.children)}
                                    </Tooltip>
                                )});
                    }
                    break;
            }
        } else return null;
    }
}
